import React from "react";
import "../scss/skill.scss";

const Skill = ({ skillIcon, skillHeading, skillsList, id }) => {
  return (
    <div id={id} className="skill">
      <div className="skill_imgHeadingContainer">
        <img
          className="skill_icon"
          src={`/icons/${skillIcon}`}
          alt={skillHeading}
        />
        <h3 className="skill_heading">{skillHeading}</h3>
      </div>
      <ul className="skill_list">
        {skillsList.map((skill) => {
          return (
            <li key={skill.skillName} className="skill_list_item">
              <img
                className="skill_list_item_icon"
                src={`/icons/${skill.skillImage}.svg`}
                alt={skill.skillName}
              />
              {skill.skillName}
            </li>
          );
        })}
        {/* <li className="skill_list_item">
          <img
            className="skill_list_item_icon"
            src="/icons/html.svg"
            alt="hh"
          />
          HTML/CSS
        </li>
        <li className="skill_list_item">
          <img
            className="skill_list_item_icon"
            src="/icons/html.svg"
            alt="hh"
          />
          HTML/CSS
        </li>
        <li className="skill_list_item">
          <img
            className="skill_list_item_icon"
            src="/icons/html.svg"
            alt="hh"
          />
          HTML/CSS
        </li>
        <li className="skill_list_item">
          <img
            className="skill_list_item_icon"
            src="/icons/html.svg"
            alt="hh"
          />
          HTML/CSS
        </li>
        <li className="skill_list_item">
          <img
            className="skill_list_item_icon"
            src="/icons/html.svg"
            alt="hh"
          />
          HTML/CSS
        </li> */}
      </ul>
    </div>
  );
};

export default Skill;
